module.exports = __webpack_public_path__ + "static/about-thumbnail-284f03cba3bf1f146a8669813f15f87e.png";